import { callApi, ENDPOINTS } from 'utils/api/callApi'
import { IDeclineShipmentOfferResponse, IGetShipmentOffersResponse } from 'apps/fleet-planner/types'

export const fetchShipmentOffers = (): Promise<IGetShipmentOffersResponse> => {
  return callApi({
    endpoint: ENDPOINTS.fleetPlannerShipmentOffers,
    method: 'GET',
  })
}

export const declineShipmentOffer = (
  shipmentId: number
): Promise<IDeclineShipmentOfferResponse> => {
  return callApi({
    endpoint: ENDPOINTS.fleetPlannerShipmentOffersDecline,
    group: `${shipmentId}/decline`,
    method: 'PUT',
    body: {
      shipmentId,
    },
  })
}
